import { render, staticRenderFns } from "./InboundDelivery.vue?vue&type=template&id=3805785f&"
import script from "./InboundDelivery.vue?vue&type=script&lang=js&"
export * from "./InboundDelivery.vue?vue&type=script&lang=js&"
import style0 from "./InboundDelivery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports